import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";

@Injectable({
  providedIn: 'root'
})
export class GpAddressFollowUpApiService {
  private http = inject(HttpClient);

  private env = inject<PIMSEnvironment>(ENVIRONMENT)

  sendFollowUpMessage(address_id: string, visit_id: string, message: string) {
    return this.http.post(`${this.env.constants.API_URL}/gpaddresses/${address_id}/orders/${visit_id}/followup/`, {
      data: {
        type: "gpaddresses",
        attributes: {
          content_type: "message",
          content: message
        }
      }
    })
  }

}
